import { Stack } from '@mui/material';
import { getInitials } from '@/utils/getInitials';
import { NoteCardUser } from '../types';
import { Avatar } from '../../ui/Avatar';
import { FAIcon } from '@packages/ui-components';

type Props = {
  assignee?: NoteCardUser;
  reporter: NoteCardUser;
};

export function ReporterAssignee({ reporter, assignee }: Props) {
  return (
    <Stack direction="row" gap="5px" alignItems="center">
      <Avatar src={reporter.avatarUrl} alt={reporter.name} bgColor={reporter.color}>
        {getInitials(reporter.name)}
      </Avatar>

      {assignee ? (
        <Stack direction="row" gap="5px" alignItems="center" className="assignee-container">
          <FAIcon
            icon="faArrowRight"
            size={10}
            color="var(--Gray-500, #667085)"
          />
          <Avatar src={assignee.avatarUrl} alt={assignee.name} bgColor={assignee.color}>
            {getInitials(assignee.name)}
          </Avatar>
        </Stack>
      ) : null}
    </Stack>
  );
}
